export enum TenantStatus {
  ARCHIVED = 'ARCHIVED',
  ACTIVE = 'ACTIVE',
}
